// Add Event function
const addClickEvent = (object, callback) => {
  object.click(callback);
};

const addEvent = (object, eventType, callback) => {
	if (object === null || typeof(object) === 'undefined') return;

	if (object.addEventListener) {
			object.addEventListener(eventType, callback, false);
	} else if (object.attachEvent) {
			object.attachEvent("on" + eventType, callback);
	} else {
			object["on"+eventType] = callback;
	}
};

const burgHandler = () => {
  const burg = document.querySelector('.wmk-burg');
  
  burg.classList.toggle('clicked');
}

const menuSingleBkgd = () => {
  const cahpHero = document.getElementById('the-hero');
  const heroRect = cahpHero.getBoundingClientRect();
  const cahpHeader = document.querySelector('.wmk-header-wrap');
  const cahpMenu = document.querySelector('.main-menu-wrap');

  if ( heroRect.bottom < cahpHeader.offsetHeight && ! cahpHeader.classList.contains('bkgd') ) {
    cahpHeader.classList.add('bkgd');
  } else if ( heroRect.bottom > cahpHeader.offsetHeight && cahpHeader.classList.contains('bkgd') ) {
    cahpHeader.classList.remove('bkgd');
  }
}

const windowScrollHandler = () => {
  menuSingleBkgd();
}

/* const burgHandler = () => {
  //console.log('burger clicked');
  const burg = jQuery('.wmk-burg');
  const open = 'burger-open';
} */

const cahpStickyScrollHandler = () => {
  const sticky = jQuery('#wmk-header-sticky');
  const threshold = sticky.height();
  let pos = window.scrollY;
  if (pos > threshold) {
    sticky.addClass('stuck');
  } else {
    sticky.removeClass('stuck');
  }
}

// cahp sticky functions
const cahpStickyHasHero = (selector) => {
  return jQuery(selector).length ? true : false;
}
const cahpStickyAdminOffset = ($el) => {
  const admin = jQuery('#wpadminbar');
  if (admin.length) {
    //console.log(admin.height());
    $el.css({ "top": admin.height() });
  }
}
const cahpStickyWithHero = ($el) => {
  $el.addClass('has-hero');

}
const cahpStickyWithoutHero = ($el) => {
  $el.addClass('has-no-hero');
}
const cahpSticky = () => {
  const sticky = jQuery('#wmk-header-sticky');
  cahpStickyAdminOffset(sticky);
  if (sticky) {
    window.addEventListener('scroll', cahpStickyScrollHandler);
    if (cahpStickyHasHero('#the-hero')) {
      cahpStickyWithHero(sticky);
    } else {
      cahpStickyWithoutHero(sticky);
    }
  }

}

jQuery(document).ready(function () {

  /* These functions make sure WordPress and Foundation play nice together. */

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  });

  // select Hamburger and add click event
  // const burg = jQuery('.wmk-burg'); //document.querySelector('.wmk-burg');
  // if (burg) {
  //   addClickEvent(burg, burgHandler);
  // }
  const burg = document.querySelector('.wmk-burg');
  if ( burg ) {
    addEvent(burg, 'click', burgHandler);
  }

  var isSingle = document.querySelector('.single-post');

  if ( isSingle ) {
    addEvent(window, 'scroll', windowScrollHandler);
    menuSingleBkgd();
  }
  
  // cahpSticky();
}); 